import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveForm30ColorSettings, SaveForm30ColorSettingsRequest } from '../../services/network/form30ColorSettings-api';

export const useSaveForm30ColorSettings = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (data: SaveForm30ColorSettingsRequest) => saveForm30ColorSettings(data),
        onSuccess: (_, variables) => {
            // Инвалидируем кэш для обновления данных
            queryClient.invalidateQueries({
                queryKey: ['form30ColorSettings', variables.year, variables.table_id, variables.row_id, variables.column_key]
            });
        },
    });

    return {
        saveColorSettings: mutation.mutate,
        isLoading: mutation.isPending,
        isError: mutation.isError,
        isSuccess: mutation.isSuccess,
        error: mutation.error
    };
};
